import React, { useEffect, useRef, useState } from 'react';

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  const trackRef = useRef(null);
  const draggingRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const h = doc.scrollHeight - doc.clientHeight;
      const p = h > 0 ? (window.scrollY / h) * 100 : 0;
      setProgress(p);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const jumpToClientY = (clientY, smooth = true) => {
    if (!trackRef.current) return;
    const rect = trackRef.current.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (clientY - rect.top) / rect.height));
    const doc = document.documentElement;
    const target = ratio * (doc.scrollHeight - doc.clientHeight);
    window.scrollTo({ top: target, behavior: smooth ? 'smooth' : 'auto' });
  };

  const onTrackClick = (e) => {
    if (draggingRef.current) return;
    jumpToClientY(e.clientY);
  };

  const startDrag = (initialClientY) => {
    draggingRef.current = true;
    jumpToClientY(initialClientY, false);
    const onMove = (ev) => {
      if (!draggingRef.current) return;
      const cy = ev.touches ? ev.touches[0].clientY : ev.clientY;
      jumpToClientY(cy, false);
    };
    const onUp = () => {
      draggingRef.current = false;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);
  };

  const onHandleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    startDrag(e.clientY);
  };

  const onHandleTouchStart = (e) => {
    e.stopPropagation();
    startDrag(e.touches[0].clientY);
  };

  return (
    <div
      className="scroll-track"
      ref={trackRef}
      onClick={onTrackClick}
      role="slider"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progress)}
      aria-label="Page scroll"
    >
      <div className="label">SCROLL</div>
      <div className="rail" />
      <div className="fill" style={{ height: `${progress}%` }} />
      <div
        className="handle"
        style={{ top: `${progress}%` }}
        onMouseDown={onHandleMouseDown}
        onTouchStart={onHandleTouchStart}
      />
      <div className="percent">{String(Math.round(progress)).padStart(2, '0')}%</div>
    </div>
  );
}
